enum PersonTypeEnum {
  PF = 'PF',
  PJ = 'PJ',
}

export default PersonTypeEnum
